<template>
  <section class="pa-section pa-section-park-note-detail">
    <div class="pa-back-button">
      <router-link :to="{ name: 'parks.detail', params : {parkId:this.parkId}}">←ひろばに戻る</router-link>
    </div>

    <div class="park-info">
      <PAParkBanner :parkId="this.parkId" />
    </div>

    <div class="park-note-detail">
      <PAParkNote :parkNoteId="this.noteId"/>
    </div>

    <div class="pa-back-button pa-back-button-bottom">
      <router-link :to="{ name: 'parks.detail', params : {parkId:this.parkId}}">←ひろばに戻る</router-link>
    </div>
  </section>
</template>

<script>
import PAParkBanner from '@/components/Parts/PAParkBanner/PAParkBanner.vue'

import PAParkNote from '@/components/Pages/Parks/Note/PAParkNote/PAParkNote.vue'

export default {
  components : {
    PAParkBanner,
    PAParkNote
  },

  computed : {
    parkId(){
      return this.$route.params.parkId;
    },

    noteId(){
      return this.$route.params.noteId;
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-section{
  &-park-note-detail{
    padding-top:.5rem !important;
    margin-bottom:1.5rem;

    .pa-back-button{
      width:98%;
      margin:0 auto .3rem;

      @include from($desktop) {
        margin:.2rem auto .8rem;
      }

      a{
        display: block;
        background-color: #C2A78F;
        color: #7C5E49;
        font-size:.9rem;
        border-radius: 8px;
        padding:.2rem .6rem;
        text-align: center;
        letter-spacing: .1rem;
        user-select: none;

        @include from($desktop) {
          font-size:1.1rem;
        }
      }

      &-bottom{
        margin-bottom: 10px;
      }
    }

    .park-info{
      width:98%;
      margin:.8rem auto;

      @include from($desktop) {
        margin:1rem auto;
      }
    }

    .park-note-detail{
      width:98%;
      margin:.8rem auto;
      
      @include from($desktop) {
        margin:1rem auto;
      }
    }
  }
}
</style>